import React, {
  useEffect,
  useState,
} from "react";


export default function CommerceAgendaMeetingNoShowDialog({
  open,
  saving = false,
  contactName = "",
  onPlanNewMeeting,
  onDoNotPlan,
  onSkip,
  onClose,
}) {
  const [
    reason,
    setReason,
  ] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center acta-modal-overlay p-3 sm:p-4"
      role="dialog"
      aria-modal="true"
      data-testid="agenda-meeting-no-show-dialog"
      onClick={() => {
        if (!saving) {
          onClose?.();
        }
      }}
    >
      <div
        className="acta-modal-surface w-full rounded-3xl bg-[var(--do-bg-solid)] p-5 shadow-2xl sm:max-w-lg sm:p-6"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="label-eyebrow">
              Agenda commercial
            </div>

            <h2 className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]">
              Rendez-vous non fait
            </h2>

            {contactName ? (
              <p className="mt-1 text-sm text-[var(--do-muted)]">
                {contactName}
              </p>
            ) : null}
          </div>

          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            aria-label="Fermer"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[var(--do-border)] text-xl font-black text-[var(--do-muted)] disabled:opacity-50"
          >
            ×
          </button>
        </div>

        <label className="mt-5 block">
          <span className="text-xs font-bold text-[var(--do-muted)]">
            Pourquoi le rendez-vous n’a pas eu lieu ?
          </span>

          <textarea
            rows={4}
            maxLength={2000}
            value={reason}
            onChange={(event) =>
              setReason(
                event.target.value
              )
            }
            placeholder="Note facultative"
            data-testid="agenda-meeting-no-show-note"
            className="mt-2 w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 py-3 text-base text-[var(--do-ink)] outline-none focus:border-[var(--do-accent)]"
          />
        </label>

        <div className="mt-5">
          <div className="text-xs font-black uppercase tracking-[0.08em] text-[var(--do-muted)]">
            Souhaitez-vous replanifier ?
          </div>

          <div className="mt-3 space-y-2">
            <button
              type="button"
              disabled={saving}
              onClick={() =>
                onPlanNewMeeting?.(
                  reason.trim()
                )
              }
              data-testid="agenda-meeting-no-show-replan"
              className="min-h-[50px] w-full rounded-xl bg-[var(--do-accent)] px-5 text-sm font-black text-[var(--do-on-accent)] disabled:opacity-50"
            >
              Planifier un nouveau rendez-vous
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={() =>
                onDoNotPlan?.(
                  reason.trim()
                )
              }
              data-testid="agenda-meeting-no-show-no-replan"
              className="min-h-[50px] w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-5 text-sm font-black text-[var(--do-ink)] disabled:opacity-50"
            >
              Ne pas replanifier
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={onSkip}
              data-testid="agenda-meeting-no-show-skip"
              className="min-h-[46px] w-full rounded-xl px-5 text-sm font-bold text-[var(--do-muted)] hover:bg-[var(--do-surface-soft)] disabled:opacity-50"
            >
              Passer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
